<template>
  <div class="container">
    <div class="jumbotron m-3">
      <h2 class="mb-5 text-center">Visualizar Notícias</h2>

      <div class="col-12">
        <v-text-field
          filled
          label="Pesquisar Notícia"
          append-icon="fas fa-search"
          v-model="filtro"
          @input="filtrarNoticias"
          clearable
        ></v-text-field>
      </div>
      <div class="row">
        <div class="col-md-12 text-center mb-4" v-if="visiblePages.length == 0 && !filtro">
          <h4>Carregando notícias...</h4>
          <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        </div>
        <div class="col-md-12 text-center mb-4" v-if="visiblePages.length == 0 && filtro">
          <h5>Sua pesquisa '{{filtro}}' não teve resultado!</h5>
        </div>
        <div class="col-md-3" v-for="item in visiblePages" :key="item.postId">
          <v-card class="mx-auto card-outter" max-width="400" height="100%">
            <v-card-title class="text-break size-title">{{ item.titulo }}</v-card-title>
            <v-img  height="150px" width="100%" :src="item.imagem" aspect-ratio="2" contain></v-img>
            <div class="text-right">
              <v-card-subtitle class="pb-0">
                {{
                item.dataPublicacao
                }}
              </v-card-subtitle>
            </div>

            <v-card-subtitle class="pb-0">{{ item.categoria }}</v-card-subtitle>

            <v-card-text class="text--primary">
              <div>{{ item.assunto }}</div>
            </v-card-text>

            <v-card-actions class="card-actions">
              <v-btn color="blue" text v-on:click="visualizarNoticia(item.postId)">Saiba Mais</v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </div>
      <div class="text-center">
        <v-pagination v-model="page" :length="Math.ceil(posts.length / perPage)"></v-pagination>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import moment from "moment";
import router from "../router";
import EventBus from "./EventBus";
export default {
  data() {
    return {
      categorias: [],
      posts: [],
      filtro: "",
      postsOriginal: [],
      page: 1,
      perPage: 8,
    };
  },
  mounted() {
    this.getCategorias();
    this.getPosts();
  },
  computed: {
    visiblePages() {
      return this.posts.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      );
    },
  },
  methods: {
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[èéêë]/, "e");
      str = str.replace(/[ÌÍÎÏ]/, "I");
      str = str.replace(/[ìíîï]/, "i");
      str = str.replace(/[ÒÓÔÕÖ]/, "O");
      str = str.replace(/[òóôõö]/, "o");
      str = str.replace(/[ÙÚÛÜ]/, "U");
      str = str.replace(/[ùúûü]/, "u");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      str = str.replace(/[Ñ]/, "N");
      str = str.replace(/[ñ]/, "n");

      return str.replace(/[^a-z0-9]/gi, "");
    },
    filtrarNoticias() {
      if (this.filtro)
        this.posts = this.postsOriginal.filter(
          (x) =>
            this.replaceSpecialChars(x.titulo.toLowerCase()).includes(
              this.filtro.toLowerCase()
            ) ||
            this.replaceSpecialChars(x.assunto.toLowerCase()).includes(
              this.filtro.toLowerCase()
            ) ||
            this.replaceSpecialChars(x.categoria.toLowerCase()).includes(
              this.filtro.toLowerCase()
            ) ||
            this.replaceSpecialChars(x.dataPublicacao.toLowerCase()).includes(
              this.filtro.toLowerCase()
            )
        );
      else this.posts = this.postsOriginal;
    },
    visualizarNoticia(id) {
      router.push({ path: `/noticia/${id}` }).catch(() => {});
    },
    getCategorias() {
      axios.get("https://www.sabios.net.br/api/categoria").then(
        (rs) => {
          this.categorias = rs.data;
        },
        (err) => console.log("Error: " + err)
      );
    },
    getPosts() {
      this.posts = new Array();
      axios.get("https://www.sabios.net.br/api/post").then(
        (rs) => {
          rs.data.forEach((post) => {
            const byteString = atob(post.imagem.split(",")[1]);
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i += 1) {
              ia[i] = byteString.charCodeAt(i);
            }
            const newBlob = new Blob([ab], {
              type: "image/jpeg",
            });

            post.imagem = window.URL.createObjectURL(newBlob);

            let categoria = this.categorias.find(
              (x) => x.categoriaId == post.categoriaId
            );

            if (categoria) post.categoria = categoria.titulo;

            if (post.dataPublicacao)
              post.dataPublicacao = moment(
                post.dataPublicacao,
                "YYYY-MM-DD"
              ).format("DD/MM/YYYY");
          });
          rs.data.sort((a, b) => a.dataPublicacao.localeCompare(b.data));

          this.posts = rs.data;
          this.postsOriginal = rs.data;
          this.loading = false;
        },
        (err) => console.log("Error: " + err)
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/VisualizarPosts.vue